// タイムラインビュー（読了の年表）
import { escapeHtml, screenHead, showScreen, fmtDate } from '../ui.js';
import { getAllBooks } from '../cache.js';
import { showBookDetailScreen } from './book-detail.js';

const GENRE_PALETTE = {
  '哲学': 1, 'ビジネス': 0.85, '歴史': 0.7, 'ファッション': 0.55,
  'アート': 0.4, '小説': 0.3, 'エッセイ': 0.2, '写真': 0.12,
};

export async function showTimelineScreen() {
  const books = await getAllBooks();
  const completed = books.filter((b) => b.status === '読了' && b.endDate).sort((a, b) => b.endDate.localeCompare(a.endDate));
  const byYear = groupByYear(completed);

  const html = `
    ${screenHead('タイムライン')}
    <p style="color:var(--dim);font-size:13px;line-height:1.75;margin:0 0 24px;">
      読了書籍の年表とジャンル分布。タップで詳細へ。
    </p>
    ${Object.keys(byYear).length === 0 ? '<p class="empty">読了済みの書籍がまだありません。</p>' : ''}
    ${Object.entries(byYear)
      .map(([year, list]) => renderYear(year, list))
      .join('')}
  `;
  const screen = showScreen('timeline', html);
  screen.querySelector('[data-action="back"]').addEventListener('click', () => window.history.back());
  screen.querySelectorAll('[data-book-id]').forEach((el) => {
    el.addEventListener('click', () => showBookDetailScreen(el.dataset.bookId));
  });
}

function groupByYear(books) {
  const map = {};
  for (const b of books) {
    const y = (b.endDate || '').slice(0, 4);
    if (!y) continue;
    if (!map[y]) map[y] = [];
    map[y].push(b);
  }
  return Object.fromEntries(
    Object.entries(map).sort(([a], [b]) => b.localeCompare(a))
  );
}

function renderYear(year, books) {
  // ジャンル別の冊数を集計してバー描画
  const genreCount = {};
  for (const b of books) {
    for (const g of b.genre || []) {
      genreCount[g] = (genreCount[g] || 0) + 1;
    }
  }
  const total = books.length;
  const genres = Object.entries(genreCount).sort((a, b) => b[1] - a[1]);

  return `
    <div class="timeline-year">
      <div class="timeline-year__head">
        <span class="timeline-year__num">${escapeHtml(year)}</span>
        <span class="timeline-year__count">${total} 冊</span>
      </div>
      <div class="timeline-year__bar">
        ${genres
          .map(([g, n]) => {
            const w = (n / total) * 100;
            const opacity = GENRE_PALETTE[g] ?? 0.5;
            return `<div class="timeline-year__seg" style="width:${w}%;opacity:${opacity};" title="${escapeHtml(g)}: ${n}"></div>`;
          })
          .join('')}
      </div>
      <div class="timeline-year__legend">
        ${genres.map(([g, n]) => `<span>${escapeHtml(g)} ${n}</span>`).join('')}
      </div>
      <ul style="list-style:none;padding:0;margin:12px 0 0;">
        ${books
          .map(
            (b) => `
          <li data-book-id="${escapeHtml(b.id)}" style="display:flex;gap:10px;padding:8px 0;border-bottom:1px solid var(--line);cursor:pointer;align-items:baseline;">
            <span style="font-family:var(--font-mono);font-size:11px;letter-spacing:0.08em;color:var(--mute);flex-shrink:0;min-width:64px;">${fmtDate(b.endDate)}</span>
            <span style="flex:1;font-family:var(--font-serif);font-size:13px;line-height:1.4;">${escapeHtml(b.name)}<span style="color:var(--mute);"> / ${escapeHtml(b.author || '')}</span></span>
            ${b.rating ? `<span style="font-size:10px;color:var(--mute);flex-shrink:0;">${escapeHtml(b.rating)}</span>` : ''}
          </li>
        `
          )
          .join('')}
      </ul>
    </div>
  `;
}
